'use client';
import posthog from 'posthog-js';
import { AccountType } from '@/autogenerated/@prisma/prisma-mongo-client';
import { logger } from '@/lib/clientSideLogger';

export const pushAnalyticsEvent = (
  eventName: string,
  parameters?: Record<string, string | number | boolean>
) => {
  try {
    posthog.capture(eventName, parameters);
    if (process.env.NODE_ENV === 'development') {
      logger('log', `event pushed: ${eventName} ${JSON.stringify(parameters)}`);
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      if (error instanceof Error) {
        logger('error', error);
      } else {
        logger('error', new Error(String(error)));
      }
    }
  }
};

export const identify = (user: {
  id: string;
  email?: string | null;
  name?: string | null;
  accountType?: AccountType;
  idVerificationStatus?: boolean;
}) => {
  posthog.identify(user.id, {
    email: user.email,
    name: user.name,
    accountType: user.accountType,
    isVerified: user.idVerificationStatus,
  });
};
